/* jshint strict: false */

var MbSeminarBookmark = {
	init: function () {
		MbSeminarBookmark.disableBookmark();
		MbSeminarBookmark.handleBookmark();
	},

	handleBookmark: function() {
		$('a.bookmark, button.waitlist').off('click')
			.on('click', function(e){
				e.preventDefault();

				var $this = $(this);
				var frm = $this.closest('form');
				var data = 'act=bookmark_event&' + frm.serialize();

				$.ajax({type: 'POST', url: 'mbsem_ajax.php', data: data, success: function(response) {
						if (response.result === 'success') {

							if (response.redirecturl && response.redirecturl.length>0) {
								document.location.href = response.redirecturl;
								return;
							}

							var el = $('a#bm_event_' + response.data.event_id);
							if (response.bookmarked === '1') {
								el.attr('title', response.data.title).text(response.data.label).addClass('active');
								frm.find('input[name=state]').val('0');
							} else if (response.bookmarked === '0') {
								if (response.data.moduleType === 'watchlist' || response.data.moduleType === 'waitlist'){
									var listItem = frm.parent('li');
									$(listItem).slideUp(400, function(){
										this.remove();
									});
								} else {
									el.attr('title', response.data.title).text(response.data.label).removeClass('active');
									frm.find('input[name=state]').val('1');
								}
							}
						}
					},
					dataType: 'json'
				});

				return false;
			});
	},

	disableBookmark: function() {
		$('a.bookmark').attr('onclick', null);
	}
};

var MbSeminarScrollTo = {
	config: {},

	init: function(options) {
		MbSeminarScrollTo.config = options;

		var y = MbSeminarScrollTo.getCookie();
		if (y !== '' && y > 0) {
			$(window).scrollTop(y);
			MbSeminarScrollTo.setCookie(0);
		}

		$(MbSeminarScrollTo.config.selector).on('click.mbsem', function(){
			MbSeminarScrollTo.setCookie($(window).scrollTop());
		});
	},

	setCookie: function(cval){
		document.cookie = 'MBSEM_Y=' + cval;
	},

	getCookie: function(){
		var name = 'MBSEM_Y=';
		var ca = document.cookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) === ' '){
				c = c.substring(1);
			}
			if (c.indexOf(name) === 0) {
				return c.substring(name.length, c.length);
			}
		}
		return '';
	}
};

(function($) {
	$(document).ready(function(){
		MbSeminarBookmark.init();
	});
})(jQuery);

(function($) {
	$(window).on('load', function(){
		var elErr = $('p.error, div.error');
		if (elErr.length > 0){
			var offset = $(elErr).offset();
			$(window).scrollTop((offset.top - 100));
		}

		MbSeminarScrollTo.init({selector: 'table.minicalendar th.previous a, table.minicalendar th.next a, #filter_submit, #filter_reset'});
	});
})(jQuery);

